/* eslint-disable import/first */
import Vue from "vue";
import {EventBus} from "../../event-bus.js";
import VueRouter from "vue-router";
Vue.use(VueRouter);
import List from "./components/List.vue";
// import Edit from "./components/Edit.vue";
import Create from "./components/Create.vue";
import {routeNames} from "./routeNames.js";
import {afterEachRouteChange} from "../router-helpers.js";

// I dont know why the VueRouter.base is not working, but this is working as expected.
// Of course, we can pass the base path as variable from external if we want.
const basePath = "/commerce/customers/webhooksgroups/";

export function buildRouter() {
	console.info("building a new router");
	const routes = [
		// {
		// 	path: basePath + "list_:customer",
		// 	redirect: {name: routeNames.List}
		// },
		{path: basePath + ":customer/list/", name: routeNames.List, component: List, alias: basePath + "list_:customer"}, /*, meta: {pageTitle: "List"} */
		// {path: basePath + "edit222/:id", component: Edit, props: true, meta: {pageTitle: "Edit Incoming SMS for Number", parentName: "List"}},
		{path: basePath + ":customer/create/", name: routeNames.Create, component: Create, props: {isNew: true, default: true}, meta: {pageTitle: "New", parentName: routeNames.List}}
	];

	const router = new VueRouter({
		routes, mode: "hash"
	});

	router.afterEach(afterEachRouteChange(routes, EventBus, router));

	return {router};
}
